/*
* Created on Nov 03, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import React, {useEffect, useState} from 'react';
import useToggle from "../../../hook/ToggleHook";
import {useTranslation} from "react-i18next";
import {useRegion} from "../../../context/RegionContext";
import {getCountryList} from "../../../service/common";
import {useCountryList} from "../../../context/CountryListContext";
import axios from "axios";


const CountrySelectComponent = ({field_name, input, setInput, useLocale, empty_text, onChange, disabled, useSearch=false, detectCountry=false, add_scroll=false}) => {
    const [open, node] = useToggle();
    const {t} = useTranslation();
    const {region} = useRegion();
    const {list: baseList} = useCountryList();
    const [onSearchInput, setOnSearchInput] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [showError, setShowError] = useState(false);
    const [errMessage, setErrMessage] = useState();
    const country_list = getCountryList(region, baseList);

    const onSelected = (value) => {
        let new_val = value;
        if (value === 'Hong Kong, China' || value === 'Taiwan, China') {
            new_val = value.replace(', China', '');
        }
        setInput((prevInput) => {
            prevInput[`${field_name}`] = {
                value: new_val,
                error: null,
                required: prevInput[`${field_name}`].required
            }
            return {...prevInput}
        });
        if (onChange && onChange instanceof Function) {
            onChange()
        }
        setOnSearchInput(false);
    };

    const displayCountry = (value, isLocal) => {
        if (!value) return empty_text

        let name = value;
        if (region === 'CHINA') {
            if (value === 'Hong Kong' || value === 'Taiwan') {
                name = `${value}, China`
            }
        }
        if (isLocal) {
            return t(`@${name}@`);
        }
        return name
    }

    useEffect(() => {
        let isMounted = true;
        if (detectCountry) {
            const cancelToken = axios.CancelToken.source();
            axios.get('/ajax/country', {cancelToken: cancelToken.token}).then(resp=>{
                console.log(resp);
                if (isMounted) {
                    onSelected(resp.data.result)
                }
            }).catch((err)=>{
                console.log(err);
                // if (isMounted) {
                //     onSelected('');
                // }
            });

            return () => {cancelToken.cancel('Country request cancelled'); isMounted = false;}
            }
    }, [detectCountry]);

    useEffect(() => {
        if (input[field_name]?.error) {
            setShowError(true);
            setErrMessage(input[field_name].error);
        }
        else {
            setShowError(false);
            setErrMessage('');
        }
    }, [input[field_name]?.error]);

    return (
        <div className="form-row">
            {/*<div className={`form-label ${input[field_name]?.required ? 'required' : ''}`}><label>{region==='CHINA' ? t('@Location@') :t('@Country@')}</label></div>*/}
            <div className={`form-label ${input[`${field_name}`]?.required ? 'required' : ''}`}><label>{t('@Location@')}</label></div>
            <div className="form-field">
                <div className={`comp-select ${open === 'show' ? 'active' : ''}`}>
                    <div className="select-toggle" ref={node}>
                        <span className={`select-label ${disabled ? 'color-gray-light' : ''}`}>
                            {/*{input?.[field_name]?.value && useLocale ? t(`@${input[field_name]?.value}@`) : input[field_name].value || empty_text}*/}
                            {displayCountry(input?.[`${field_name}`].value, useLocale)}
                            <input name={field_name} type="text" value={input[`${field_name}`].value} className='hide' onChange={()=>{}}/>
                            {/*{!input[field_name]?.value && useLocale ? t(`@${empty_text}@`) : empty_text}*/}
                        </span>
                    </div>
                    <div
                        className={`comp-dropdown comp-select-dropdown ${(open === 'show' || onSearchInput) && !disabled ? '' : 'hide'}`}>
                        <ul className={`comp-dropdown-menu !max-w-40vw ${add_scroll ? 'add-scroll' : ''} overlay-scroll`}>
                            {useSearch &&
                                <li className="section func-section contacts-filter">
                                    <div className="filter-bar">
                                        <input type="text" placeholder={t('@Search@')}
                                               onFocus={e => setOnSearchInput(true)}
                                               onChange={e => {
                                                   setSearchQuery(e.target.value);
                                               }}
                                        />
                                    </div>
                                </li>
                            }

                            <li className="section add-scroll">
                                {country_list.filter(c=>t(`@${c}@`).match(new RegExp(searchQuery, 'i'))).map((item, index) => {
                                        return <div className="section-items selection"
                                                    key={index}
                                                    onClick={() => onSelected(item)}>{useLocale ? t(`@${item}@`) : item}</div>
                                    }
                                )}
                            </li>
                        </ul>
                    </div>
                </div>
                <div className={`error-msg ${showError ? '' : 'hide'}`}>{errMessage}</div>
            </div>
        </div>
    );
};

export default CountrySelectComponent;